/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsdeletetype2Inputs */

const en_ticketsdeletetype2 = /** @type {(inputs: Ticketsdeletetype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete ticket type`)
};

const de_ticketsdeletetype2 = /** @type {(inputs: Ticketsdeletetype2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketart löschen`)
};

/**
* | output |
* | --- |
* | "Delete ticket type" |
*
* @param {Ticketsdeletetype2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsdeletetype2 = /** @type {((inputs?: Ticketsdeletetype2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsdeletetype2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsdeletetype2(inputs)
	return de_ticketsdeletetype2(inputs)
});
export { ticketsdeletetype2 as "ticketsDeleteType" }